import React from 'react';
import ReactDOM from 'react-dom';
import { SiteSettings } from '../../../../utils/environment';
import { GWPandLoyaltyGeoSettings } from 'src/scripts/globals';
import { LoyaltySuccessModal } from './LoyaltySuccessModal';
import { getLoyaltyBlockedStatus } from '../../loyaltyBlockedStatus';
import { IS_USER_JUST_AUTHORIZED } from '../../../../utils/constants';
import { ShippingCountryState } from '../../../../utils/shipping';
import { isInGeotarget } from '../../../../utils/location';

// Loyalty celebratory modal logic — first time view
const computeViewsAndConditionallyShowLoyaltyModal = async () => {
  const mountNodes = Array.from(document.querySelectorAll('[react-render-target="loyalty-success-modal"]'));
  const customerID = SiteSettings?.customerID;
  const loyaltySettings = await GWPandLoyaltyGeoSettings();
  const shouldRenderLoyalty =
    loyaltySettings.shouldRenderLoyaltyForDomestic || loyaltySettings.shouldRenderLoyaltyWidgetForINTL;

  if (
    !customerID ||
    !shouldRenderLoyalty ||
    !window.getCustomerInfo?.().isCustomer ||
    (await getLoyaltyBlockedStatus())
  )
    return;

  const isInUSgeo = await isInGeotarget({ countries: ['US'] });
  const isInUS = ShippingCountryState.countryCode ? ShippingCountryState.countryCode === 'US' : isInUSgeo;
  const modalSettings = isInUS ? window?.getSuccessModalSettings?.() : window?.getINTLSuccessModalSettings?.();

  const { showOnce } = modalSettings || {};
  const localstorageKey = `has_seen_loyalty_modal_${customerID}`;
  if (localStorage.getItem(localstorageKey) && showOnce) {
    return;
  } else if (!showOnce) {
    if (!IS_USER_JUST_AUTHORIZED) return;
  }

  if (modalSettings && mountNodes.length > 0) {
    mountNodes.forEach((node) => ReactDOM.render(<LoyaltySuccessModal modalSettings={modalSettings} />, node));
    localStorage.setItem(localstorageKey, '1');
  } else {
    console.warn('missing render target: LoyaltySuccessModal');
  }
};

export const initLoyaltySuccessModal = () => {
  computeViewsAndConditionallyShowLoyaltyModal();
};
